<div class="order-status-block {{order?.state}}"
  [class.with-status-date]="showStatusDate">
  <div class="status-text">{{order?.state || 'Undefined status'}}</div>
  @if (showStatusDate) {
  <div class="status-date">{{order?.updatedAt | date:'yyyy-MM-dd, HH:mm'}}</div>
  }
</div>
